import React, { createContext } from 'react';
import useCioAutocomplete from '../../hooks/useCioAutocomplete';
export const CioAutocompleteContext = createContext({});
export default function CioAutocompleteProvider(props) {
    const { children, ...restProps } = props;
    const cioAutocomplete = useCioAutocomplete(restProps);
    return (React.createElement(CioAutocompleteContext.Provider, { value: cioAutocomplete },
        React.createElement("div", { className: cioAutocomplete.autocompleteClassName }, children)));
}
